import { useQuery } from '@tanstack/react-query';
import { keyBy } from 'lodash';

import { StaticContentApiService } from '../../domain/static-content/static-content-api.service';
import { useUserLocale } from '../../util/locales/use-user-locale';
import { Locale } from '../../util/locales/locale.model';

export function useLinksByUserLocale(linksIds: Array<string>, enabled = true, enforcedLocale?: Locale) {
  const locale = useUserLocale() ?? enforcedLocale;

  const { fetcher: linksByIdsFetcher, key: linksByIdsKey } = StaticContentApiService.getLinksByIdsFetcher(linksIds, locale || null);

  return useQuery([linksByIdsKey], () => linksByIdsFetcher?.(), {
    enabled: enabled && !!locale,
    select: (collection) => keyBy(collection, 'id'),
  });
}
